import { useState } from "react";
import { CircularProgress } from "@mui/material";
import RefreshIcon from "../../../assets/caseMappingIcon.svg";
import CheckedIcon from "../../../assets/checkedIcon.svg";
export default function CaseTableToolbar({
  assignedFilter,
  filteredUnassignedCases,
  totalFilteredCases,
  SearchIcon,
  handleSearch,
  searchKey,
  setLimit,
  limit,
  AllCases,
  getAdmissionDialysisCaseCount,
  getAdmissionDialysisInitiatedCaseCount,
  getClaimDialysisCaseCount,
  getClaimDialysisInitiatedCaseCount,

  handleGetAllCasesClick,
  getDataCheck,
  setDataCheck,
  isLoading,
  setSelectedStage,
  assignedUserStages,
  admissionDialysisCount,
  admissionDialysisInitiationCount,
  claimDialysisCount,
  claimDialysisInitiationCount,
  rpaQueueCount,

  admissionDialysisSelected,
  setAdmissionDialysisSelected,
  admissionDialysisInitiationSelected,
  setAdmissionDialysisInitiationSelected,
  claimDialysisSelected,
  setClaimDialysisSelected,
  claimDialysisInitiationSelected,
  setClaimDialysisInitiationSelected,
  enhancementDialysisCount,
  enhancementDialysisInitiationCount,

  enhancementDialysisSelected,
  setEnhancementDialysisSelected,

  enhancementDialysisInitiationSelected,
  setEnhancementDialysisInitiationSelected,
  getEnhancementDialysisCaseCount,
  getEnhancementDialysisInitiatedCaseCount,
  getRpaQueueCaseCount,
  inRpaQueueSelected,
  setInRpaQueueSelected,
}) {
  const [searchValue, setSearchValue] = useState(searchKey);
  const admissionDialysisStages = [
    "Admission Documents Uploaded",
    "Admission Documents Re-uploaded",
    "Admission Documents Approved by Team B",
    "Admission Query Documents Uploaded",
    "Admission Query Documents Re-Uploaded",
    "Admission Query Documents Approved by Doctor",
  ];

  const admissionDialysisInitiationStages = [
    "Admission Documents Approved by Team C",
    "Admission Query Documents Approved by Sr Doctor",
  ];

  const claimDialysisStages = [
    "Claim Documents uploaded",
    "Claim Documents Approved by Team D",
    "Claim Documents Re-Uploaded",
    "Claim Query Documents Uploaded",
    "Claim Query Documents Re-uploaded",
    "Claim Documents re- uploaded",
    "Claim Query Documents Approved by Doctor",
  ];

  const claimDialysisInitiationStages = [
    "Claim Documents  Approved by Team E",
    "Claim Documents Approved by Team E",
    "Claim Query Documents Approved by Sr Doctor",
    "Claim Query Documents  Approved by Sr Doctor",
  ];
  const enhancementDialysisStages = [
    "Enhancement Documents Uploaded.",
    "Enhancement Documents Re-Uploaded",
    "Enhancement  Query Documents Uploaded",
    "Enhancement Query Documents Re-Uploaded",
    "Enhancement Documents Approved by Team D",
  ];

  const enhancementDialysisInitiationStages = [
    "Enhancement  Documents  Approved by Team E",
    "Enhancement Query Documents Approved by Doctor",
    "Enhancement Query Documents Approved by Sr Doctor",
  ];
  const inRpaQueueStages = [
    "Admission in RPA Queue",
    "Enhancement in RPA Queue",
    "Claim in RPA Queue",
  ];
  return (
    <div className="text-sm mb-4 ">
      {/* Total Cases display */}
      {isLoading ? (
        <CircularProgress size={20} />
      ) : (
        <div>
          <div className="grid grid-cols-3 gap-x-6 gap-y-4  2xl:grid-cols-6 2xl:gap-x-6 2xl:gap-y-0 3xl:gap-x-7 mb-2 ">
            <div className="col-span-1 w-full flex items-center justify-between border border-solid border-[#DEDEDE] rounded-[8px] px-[4px] py-[6px] 3xl:px-[8px] 3xl:py-[10px]">
              <div
                className="w-full flex items-center gap-1"
                onClick={() => {
                  setAdmissionDialysisSelected(!admissionDialysisSelected);
                  setDataCheck(true);
                  // reset all others

                  setAdmissionDialysisInitiationSelected(false);
                  setClaimDialysisSelected(false);
                  setClaimDialysisInitiationSelected(false);
                  setEnhancementDialysisSelected(false);
                  setEnhancementDialysisInitiationSelected(false);
                  setInRpaQueueSelected(false);

                  admissionDialysisSelected
                    ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                    : setSelectedStage({
                        id: "-1",
                        stages: admissionDialysisStages,
                      });
                }}
              >
                {admissionDialysisSelected ? (
                  <img src={CheckedIcon} alt="checked-icon" />
                ) : (
                  <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full flex-shrink-0" />
                )}

                <span className="text-xs 3xl:text-sm -tracking-[0.05em] font-medium text-[#666666] ">
                  Admission Dialysis Approval Pending
                </span>
              </div>
              {admissionDialysisCount > 0 && (
                <span className="shrink-0 w-[24px] h-[24px] 3xl:w-[36px] 3xl:h-[36px] flex items-center justify-center bg-[#FB0000] text-[#FFFFFF] text-xs 3xl:text-sm -tracking-[0.05em] font-semibold rounded-full">
                  {" "}
                  {admissionDialysisCount}
                </span>
              )}
            </div>
            <div className="col-span-1 w-full flex items-center justify-between border border-solid border-[#DEDEDE] rounded-[8px] px-[4px] py-[6px] 3xl:px-[8px] 3xl:py-[10px]">
              <div
                className="w-full flex items-center gap-1"
                onClick={() => {
                  setAdmissionDialysisInitiationSelected(
                    !admissionDialysisInitiationSelected,
                  );
                  setDataCheck(true);
                  setAdmissionDialysisSelected(false);
                  setClaimDialysisSelected(false);
                  setClaimDialysisInitiationSelected(false);
                  setEnhancementDialysisSelected(false);
                  setEnhancementDialysisInitiationSelected(false);
                  setInRpaQueueSelected(false);

                  admissionDialysisInitiationSelected
                    ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                    : setSelectedStage({
                        id: "-1",
                        stages: admissionDialysisInitiationStages,
                      });
                }}
              >
                {admissionDialysisInitiationSelected ? (
                  <img src={CheckedIcon} />
                ) : (
                  <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full shrink-0" />
                )}

                <span className="text-xs 3xl:text-sm -tracking-[0.05em] font-medium text-[#666666]">
                  Admission Dialysis Initiation Pending
                </span>
              </div>
              {admissionDialysisInitiationCount > 0 && (
                <span className="shrink-0 w-[24px] h-[24px] 3xl:w-[36px] 3xl:h-[36px] flex items-center justify-center bg-[#FB0000] text-[#FFFFFF] text-xs 3xl:text-sm -tracking-[0.05em] font-semibold rounded-full">
                  {" "}
                  {admissionDialysisInitiationCount}
                </span>
              )}
            </div>
            <div className="col-span-1 w-full flex items-center justify-between border border-solid border-[#DEDEDE] rounded-[8px] px-[4px] py-[6px] 3xl:px-[8px] 3xl:py-[10px]">
              <div
                className="w-full flex items-center gap-1"
                onClick={() => {
                  setEnhancementDialysisSelected(!enhancementDialysisSelected);
                  setDataCheck(true);

                  // reset others
                  setAdmissionDialysisSelected(false);
                  setAdmissionDialysisInitiationSelected(false);
                  setClaimDialysisSelected(false);
                  setClaimDialysisInitiationSelected(false);
                  setEnhancementDialysisInitiationSelected(false);
                  setInRpaQueueSelected(false);

                  enhancementDialysisSelected
                    ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                    : setSelectedStage({
                        id: "-1",
                        stages: enhancementDialysisStages,
                      });
                }}
              >
                {enhancementDialysisSelected ? (
                  <img src={CheckedIcon} />
                ) : (
                  <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full flex-shrink-0" />
                )}

                <span className="text-xs 3xl:text-sm -tracking-[0.05em] font-medium text-[#666666]">
                  Enhancement Dialysis Approval Pending
                </span>
              </div>
              {enhancementDialysisCount > 0 && (
                <span className="shrink-0 w-[24px] h-[24px] 3xl:w-[36px] 3xl:h-[36px] flex items-center justify-center bg-[#FB0000] text-[#FFFFFF] text-xs 3xl:text-sm -tracking-[0.05em] font-semibold rounded-full">
                  {" "}
                  {enhancementDialysisCount}
                </span>
              )}
            </div>
            <div className="col-span-1 w-full flex items-center justify-between border border-solid border-[#DEDEDE] rounded-[8px] px-[4px] py-[6px] 3xl:px-[8px] 3xl:py-[10px]">
              <div
                className="w-full flex items-center gap-1"
                onClick={() => {
                  setEnhancementDialysisInitiationSelected(
                    !enhancementDialysisInitiationSelected,
                  );
                  setDataCheck(true);

                  // reset others
                  setAdmissionDialysisSelected(false);
                  setAdmissionDialysisInitiationSelected(false);
                  setClaimDialysisSelected(false);
                  setClaimDialysisInitiationSelected(false);
                  setEnhancementDialysisSelected(false);
                  setInRpaQueueSelected(false);

                  enhancementDialysisInitiationSelected
                    ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                    : setSelectedStage({
                        id: "-1",
                        stages: enhancementDialysisInitiationStages,
                      });
                }}
              >
                {enhancementDialysisInitiationSelected ? (
                  <img src={CheckedIcon} />
                ) : (
                  <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full flex-shrink-0" />
                )}

                <span className="text-xs 3xl:text-sm -tracking-[0.05em] font-medium text-[#666666]">
                  Enhancement Dialysis Initiation Pending
                </span>
              </div>
              {enhancementDialysisInitiationCount > 0 && (
                <span className="shrink-0 w-[24px] h-[24px] 3xl:w-[36px] 3xl:h-[36px] flex items-center justify-center bg-[#FB0000] text-[#FFFFFF] text-xs 3xl:text-sm -tracking-[0.05em] font-semibold rounded-full">
                  {enhancementDialysisInitiationCount}
                </span>
              )}
            </div>
            <div className="col-span-1 w-full flex items-center justify-between border border-solid border-[#DEDEDE] rounded-[8px] px-[4px] py-[6px] 3xl:px-[8px] 3xl:py-[10px]">
              <div
                className="w-full flex items-center gap-1 "
                onClick={() => {
                  setClaimDialysisSelected(!claimDialysisSelected);
                  setDataCheck(true);
                  setAdmissionDialysisSelected(false);
                  setAdmissionDialysisInitiationSelected(false);
                  setClaimDialysisInitiationSelected(false);
                  setEnhancementDialysisSelected(false);
                  setEnhancementDialysisInitiationSelected(false);
                  setInRpaQueueSelected(false);

                  claimDialysisSelected
                    ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                    : setSelectedStage({
                        id: "-1",
                        stages: claimDialysisStages,
                      });
                }}
              >
                {claimDialysisSelected ? (
                  <img src={CheckedIcon} alt="checked-icon" />
                ) : (
                  <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full flex-shrink-0" />
                )}

                <span className="text-xs 3xl:text-sm -tracking-[0.05em] font-medium text-[#666666]">
                  Claim Dialysis Approval Pending
                </span>
              </div>
              {claimDialysisCount > 0 && (
                <span className="shrink-0 w-[24px] h-[24px] 3xl:w-[36px] 3xl:h-[36px] flex items-center justify-center bg-[#FB0000] text-[#FFFFFF] text-xs 3xl:text-sm -tracking-[0.05em] font-semibold rounded-full">
                  {claimDialysisCount}
                </span>
              )}
            </div>
            <div className="col-span-1 w-full flex items-center justify-between border border-solid border-[#DEDEDE] rounded-[8px] px-[4px] py-[6px] 3xl:px-[8px] 3xl:py-[10px]">
              <div
                className="w-full flex items-center gap-1"
                onClick={() => {
                  setClaimDialysisInitiationSelected(
                    !claimDialysisInitiationSelected,
                  );
                  setDataCheck(true);
                  setAdmissionDialysisSelected(false);
                  setAdmissionDialysisInitiationSelected(false);
                  setClaimDialysisSelected(false);
                  setEnhancementDialysisSelected(false);
                  setEnhancementDialysisInitiationSelected(false);
                  setInRpaQueueSelected(false);
                  claimDialysisInitiationSelected
                    ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                    : setSelectedStage({
                        id: "-1",
                        stages: claimDialysisInitiationStages,
                      });
                }}
              >
                {claimDialysisInitiationSelected ? (
                  <img src={CheckedIcon} alt="checked-icon" />
                ) : (
                  <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full flex-shrink-0" />
                )}

                <span className="text-xs 3xl:text-sm -tracking-[0.05em] font-medium text-[#666666]">
                  Claim Dialysis Initiation Pending
                </span>
              </div>
              {claimDialysisInitiationCount > 0 && (
                <span className="shrink-0 w-[24px] h-[24px] 3xl:w-[36px] 3xl:h-[36px] flex items-center justify-center bg-[#FB0000] text-[#FFFFFF] text-xs 3xl:text-sm -tracking-[0.05em] font-semibold rounded-full">
                  {claimDialysisInitiationCount}
                </span>
              )}
            </div>
            <div className="col-span-1 w-full flex items-center justify-between border border-solid border-[#DEDEDE] rounded-[8px] px-[4px] py-[6px] 3xl:px-[8px] 3xl:py-[10px]">
              <div
                className="w-full flex items-center gap-1"
                onClick={() => {
                  setInRpaQueueSelected(!inRpaQueueSelected);
                  setDataCheck(true);
                  setAdmissionDialysisSelected(false);
                  setAdmissionDialysisInitiationSelected(false);
                  setClaimDialysisSelected(false);
                  setEnhancementDialysisSelected(false);
                  setEnhancementDialysisInitiationSelected(false);
                  setClaimDialysisInitiationSelected(false);

                  inRpaQueueSelected
                    ? setSelectedStage({ id: "-1", stages: assignedUserStages })
                    : setSelectedStage({
                        id: "-1",
                        stages: inRpaQueueStages,
                      });
                }}
              >
                {inRpaQueueSelected ? (
                  <img src={CheckedIcon} alt="checked-icon" />
                ) : (
                  <div className="h-[28px] w-[28px] bg-white border border-solid border-[#DEDEDE] rounded-full flex-shrink-0" />
                )}

                <span className="text-xs 3xl:text-sm -tracking-[0.05em] font-medium text-[#666666]">
                  In RPA Queue
                </span>
              </div>
              {rpaQueueCount > 0 && (
                <span className="shrink-0 w-[24px] h-[24px] 3xl:w-[36px] 3xl:h-[36px] flex items-center justify-center bg-[#FB0000] text-[#FFFFFF] text-xs 3xl:text-sm -tracking-[0.05em] font-semibold rounded-full">
                  {rpaQueueCount}
                </span>
              )}
            </div>
          </div>
          <div className="flex justify-between">
            <div className="flex items-center gap-4">
              <div className="text-[18px] text-[#797979]">
                Total Cases{" "}
                {getDataCheck ? (
                  <span className="font-semibold">
                    {assignedFilter === "assigned"
                      ? 0
                      : filteredUnassignedCases}
                    {" / "}
                    {totalFilteredCases}
                  </span>
                ) : (
                  <span className="font-semibold">0{" / "}0</span>
                )}
              </div>
              <div
                className="flex items-center justify-center w-[32px] h-[32px] rounded-full border-2 border-[#d5d5d5] border-solid bg-[#f5f5f5] cursor-pointer"
                onClick={() => {
                  AllCases();
                  getAdmissionDialysisCaseCount();
                  getAdmissionDialysisInitiatedCaseCount();
                  getEnhancementDialysisCaseCount();
                  getEnhancementDialysisInitiatedCaseCount();
                  getClaimDialysisCaseCount();
                  getClaimDialysisInitiatedCaseCount();
                  getRpaQueueCaseCount();
                }}
              >
                <img src={RefreshIcon} alt="refresh-icon" />
              </div>

              <div
                className="text-sm text-white bg-[#017C57] font-semibold border border-[#017C57] border-solid px-8 py-3 rounded-full cursor-pointer"
                onClick={() => {
                  handleGetAllCasesClick(AllCases);
                }}
              >
                Get All Cases
              </div>
            </div>
            {getDataCheck && (
              <div className="flex gap-2 items-center">
                <div
                  style={{ border: "1px solid #DEDEDE" }}
                  className="flex items-center gap-2 px-4 py-[6px] ml-4 2xl:ml-0 rounded-[8px] bg-white"
                >
                  <img src={SearchIcon} alt="search-icon" />
                  <input
                    type="text"
                    className="outline-none border-0"
                    value={searchValue}
                    onChange={(e) => {
                      setSearchValue(e?.target?.value);
                      handleSearch(e);
                    }}
                    placeholder="Search Anything"
                  />
                </div>
                Limit:{" "}
                <select
                  onChange={(e) => setLimit(e.target.value)}
                  style={{ border: "1px solid #E5E5E5" }}
                  className="outline-none rounded"
                  value={limit}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="40">40</option>
                  <option value="50">50</option>
                </select>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Search input and Limit selector */}
    </div>
  );
}
